import React from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import LoadMask from "Utils/LoadMask/LoadMask";
import { useResumenConsumoProd } from "../../ResumenConsumo/hooks/useResumenConsumoProd";
import { FiltrosReporteProduccion } from "../../components/FiltrosReporteProduccion";
import { AdvertenciasReporte } from "../../ResumenConsumo/components/AdvertenciasReporte";
import { ResumenConsumoTable } from "../../../components/ResumenConsumoTable";
import "../../ResumenConsumo/styles/ResumenConsumoProd.css";

// Kg secos que cada almacén aportó a las tancadas de cada semana, para la
// producción del padre PT seleccionado
export const ResumenConsumoProdTab = () => {
    const hook = useResumenConsumoProd();

    const semanasIncompletas = hook.resumen
        ? hook.resumen.semanas_incompletas
        : [];

    return (
        <div className="reportes-produccion__tab-wrapper">
            <CardEmpty noShadow>
                <LoadMask loading={hook.cargando} blur>
                    <div className="reportes-produccion__table-header">
                        <FiltrosReporteProduccion hook={hook} />

                        <div
                            className="formulario-field mb-0 no-flex"
                            style={{ maxHeight: "51px" }}
                        >
                            <button
                                className="btn btn-secondary mt-auto text-nowrap"
                                onClick={hook.descargarExcel}
                                disabled={hook.cargando}
                            >
                                Exportar a Excel
                            </button>
                        </div>
                    </div>

                    <AdvertenciasReporte
                        semanasIncompletas={semanasIncompletas}
                    />

                    <ResumenConsumoTable
                        resumen={hook.resumen}
                        mensajeError={hook.mensajeError}
                    />
                </LoadMask>
            </CardEmpty>
        </div>
    );
};
